/**
 * Override core to use priority-filtered dataMapContent instead of mapping
 * all activities directly.
 */

import { getESpotDataFromName, useESpotDataFromName } from '@/data/Content/_ESpotDataFromName';
import { ID } from '@/data/types/Basic';
import { ContentProps } from '@/data/types/ContentProps';
import { dataMapContent, dataMapTitleContent } from '@/data/utils/dataMapContent';
import { useMemo } from 'react';

export const getContentCarousel = async ({ cache, id: _id, context, properties }: ContentProps) =>
	await getESpotDataFromName(cache, properties?.emsName ?? '', context);

export const useContentCarousel = (emsName: ID) => {
	const { data: _data, error, loading } = useESpotDataFromName(emsName);
	const data = useMemo(() => dataMapContent(_data), [_data]);
	const title = useMemo(() => dataMapTitleContent(_data), [_data]);

	return {
		data,
		title,
		loading,
		error,
	};
};
